/**
 * WhatsApp do setor Financeiro por unidade Zeh Motoca (E.164 só dígitos).
 * Mesma lógica do app mobile.
 */
const DEFAULT_FINANCEIRO_E164 = '5511911975992';

function normalizeCompanyName(name: string): string {
  return name
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase();
}

export function getFinanceiroWhatsAppE164(companyName?: string | null): string {
  const n = companyName?.trim() ? normalizeCompanyName(companyName) : '';
  if (n.includes('FORTALEZA')) return '5584981312929';
  if (/\bJP\b|JOAO PESSOA/.test(n)) return '5584988162008';
  if (n.includes('NATAL')) return '5511911975992';
  return DEFAULT_FINANCEIRO_E164;
}
